import { SharedModule } from './content/shared/shared.module';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MainComponent } from './main.component';
import { ContentModule } from './content/content.module';
import { RouterModule } from '@angular/router';

@NgModule({
  declarations: [MainComponent],
  imports: [
    RouterModule,
    CommonModule,
    ContentModule,
    SharedModule,
  
  ],
  exports: [
      MainComponent
  ]
})
export class MainModule { }
